import {Component, OnInit, Input } from '@angular/core';
import { CheckboxModel } from '../checkbox.model';

@Component({
    selector: 'abw-checkbox-result',
    templateUrl: './checkbox-result.component.html',
    styleUrls: ['./checkbox-result.component.scss']
})
export class CheckboxResultComponent implements OnInit {
	@Input() model: CheckboxModel;
    @Input() value: any;

    constructor(
    ) {
    }

    ngOnInit() {
    }
}